import { Doc, generateToDocFn } from '@dadohr/shared/domainTypes/document';
import {
  OktaApiIntegrationConfig,
  OktaGroup
} from '@dadohr/shared/domainTypes/integrations/oktaApi';
import { FS } from '@dadohr/shared/versions';
import {
  store,
  useMappedLoadingValue
} from '../../../../../../services/firebase';
import { useFirebaseFunction } from '../../../../../../services/firebaseFunctions';
import {
  createDocumentListenerGetter,
  useDocumentListener
} from '../../../../../../services/firecache/documentListener';
import { now, ONE_MINUTE } from '../../../../../../services/time';

export const toOktaApiConfigDoc = generateToDocFn<OktaApiIntegrationConfig>();

const COLLECTION = FS.oktaApiIntegrationConfig;
const collection = () => store().collection(COLLECTION);

export const oktaApiConfigStore = createDocumentListenerGetter(
  (orgId) => collection().doc(orgId),
  toOktaApiConfigDoc
);

export const useOktaApiConfig = (orgId: string, userId: string) => {
  return useMappedLoadingValue(
    useDocumentListener(oktaApiConfigStore(orgId)),
    (d) => {
      if (!d) {
        const n = now();
        const newConfig: Doc<OktaApiIntegrationConfig> = {
          id: orgId,
          collection: COLLECTION,
          data: {
            orgId,
            active: false,
            createdAt: n,
            createdBy: userId,
            editedAt: n,
            editedBy: userId,

            orgUrl: '',
            clientId: '',
            keyId: '',
            privateKey: ''
          }
        };
        return newConfig;
      }
      return d;
    }
  );
};

export const removeOktaApiConfig = (orgId: string) => {
  // TODO cleanup up SSO settings on org
  return collection().doc(orgId).delete();
};

export const useOktaGroupsList = (orgId: string) => {
  return useFirebaseFunction<OktaGroup[]>(
    'integrations_okta_api-getOktaGroups',
    { orgId },
    [orgId],
    ONE_MINUTE * 5
  );
};
